<template>
  <div class="my-4 max-w-3xl p-4 md:p-6 bg-mist rounded">
    <ResReqForm />
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})
</script>

<style lang="scss" scoped>
//
</style>